<script>
    import { selectedLanguage } from "../etc/store.js"
</script>

{#if $selectedLanguage == "TW"}

#### FAQ

- ##### 有關帳戶及密碼

  > 您的帳戶就是您的 email 地址，必須是能夠接收 email 的真地址。密碼的要求不多，最低要求只要 6 位即可。不過，為了安全起見，最好您的密碼至少能有 8 位，有大、小寫、有數字、有特殊符號，等等。

- ##### 我的信用卡及各資安全嗎？

  > 所有的付費手續，都是在世界知名的線上付款公司 Stripe 進行的，【XiYi 習易網】只知道是不是付款成功，不會知道、更不可能儲存任何信用卡的資料。【XiYi 習易網】唯一要求您的個人資料就只是您的 email 地址，這是因為註冊的時候，您必須能夠收到確認 email，以完成註冊手續。在註冊表格上的其他資料，我建議您填真的，所以我知道您是誰、人在哪裏，並沒有要求敏感資料。如果您要填假的，我也沒辦法。

- ##### 如果有問題、有建議、有意見，要如何與我聯絡？

  > 首先要謝謝您！請隨時用<a href="mailto:ixiyi88@gmail.com?subject=【XiYi 習易網】：訪客意見">email</a>與我聯絡。我會儘快回覆。

    <!-- - ##### 【XiYi 習易網】的 logo 是什麼意思？
      > 這個 logo 其實就是【風地觀】卦的 95 爻值宜變。【九五】：觀我生，君子无咎。代表我的心境，
      > 也是我開發【XiYi 習易網】的態度。 -->

- ##### 未來會有哪些功能更新與加強？

  > 修理緊急嚴重問題（bugs）一定是第一優先。其他的「問題」、「改善」、「新增」工作會視狀況依序安排。

  <!-- > 目前已知需要改善的項目有：
  >
  > - 【細究】：需要改善 UI，免得老是要滑上滑下。
  >
  > 目前已知想要增加的功能有：
  >
  > - 【玩卦】：能夠幫助會員背古書的小遊戲。 -->

{:else }

<h5>古籍</h5>

#### FAQ

- ##### 有关帐户及密码

  > 您的帐户就是您的 email 地址，必须是能够接收 email 的真地址。密码的要求不多，最低要求只要 6 位即可。不过，为了安全起见，最好您的密码至少能有 8 位，有大、小写、有数字、有特殊符号，等等。

- ##### 我的信用卡及各资安全吗？

  > 所有的付费手续，都是在世界知名的线上付款公司 Stripe 进行的，【XiYi 习易网】只知道是不是付款成功，不会知道、更不可能储存任何信用卡的资料。【XiYi 习易网】唯一要求您的个人资料就只是您的 email 地址，这是因为注册的时候，您必须能够收到确认 email，以完成注册手续。在注册表格上的其他资料，我建议您填真的，所以我知道您是谁、人在哪里，并没有要求敏感资料。如果您要填假的，我也没办法。

- ##### 如果有问题、有建议、有意见，要如何与我联络？

  > 首先要谢谢您！请随时用<a href="mailto:ixiyi88@gmail.com?subject=【XiYi 习易网】：访客意见">email</a>与我联络。我会尽快回复。

    <!-- - ##### 【XiYi 习易网】的 logo 是什么意思？
      > 这个 logo 其实就是【风地观】卦的 95 爻值宜变。【九五】：观我生，君子无咎。代表我的心境，
      > 也是我开发【XiYi 习易网】的态度。 -->

- ##### 未来会有哪些功能更新与加强？

  > 修理紧急严重问题（bugs）一定是第一优先。其他的「问题」、「改善」、「新增」工作会视状况依序安排。

  <!-- > 目前已知需要改善的项目有：
  >
  > - 【细究】：需要改善 UI，免得老是要滑上滑下。
  >
  > 目前已知想要增加的功能有：
  >
  > - 【玩卦】：能够帮助会员背古书的小游戏。 -->

{/if}

<style>
    p {
    font-size: 16px;
  }
    li {
    font-size: 16px;
  }
    ul li {
    margin-left: 40px;
    list-style-type: square !important;
  }
  
</style>
